import Bowser from "bowser";
import Splide from "@splidejs/splide";
import MicroModal from "micromodal";

jQuery(document).ready(function($) {
  // Inside of this function, $() will work as an alias for jQuery()
  // and other libraries also using $ will not be accessible under this shortcut
  // https://codex.wordpress.org/Function_Reference/wp_enqueue_script#jQuery_noConflict_Wrappers

  // MicroModal
  MicroModal.init({
    onShow: function () {
      document.querySelector("html").classList.add("locked");
      let video_frame = $(".is-open").find("iframe");
      let player = new Vimeo.Player(video_frame);
      player.play();
    },
    onClose: function (modal) {
      document.querySelector("html").classList.remove("locked");

      // Reset iframes on modal close
      let iframe = modal.querySelector("iframe"),
        iframeSrc = iframe.getAttribute("src");

      iframe.setAttribute("src", iframeSrc);
    }
  });

  // Touch Device Detection
  var isTouchDevice = "ontouchstart" in document.documentElement;
  if (isTouchDevice) {
    $("body").removeClass("no-touch");
    $("body").addClass("touch");
  }

  // Browser detection via Bowser (https://github.com/lancedikson/bowser) - add detection as needed
  const userBrowser = Bowser.getParser(window.navigator.userAgent);
  const browser = userBrowser.getBrowser();

  if (browser.name === "Internet Explorer" && browser.version == "11.0") {
    $("body").addClass("ie-11");
  } else if (browser.name === "Safari") {
    $("body").addClass("safari");
  } else if (browser.name === "Firefox") {
    $("body").addClass("firefox");
  }

  // Slider section (SplideJS)
  if( $(".video-grid__slider").length ) {
    $(".video-grid__slider").each(function() {
      new Splide(this, {
        type: "loop",
        perPage: 3,
        arrows: false,
        pagination: false,
        breakpoints: {
          767: {
            perPage: 2,
            arrows: true,
          },
          500: {
            perPage: 1
          }
        }
      }).mount();
    });
  }

  // Flipcards
  $(".no-touch .flipcards-section .flip-container").on("mouseenter", function() {
    $(this).addClass("flip");
  });

  $(".no-touch .flipcards-section .flip-container").on("mouseleave", function() {
    $(this).removeClass("flip");
  });

  $(".touch .flipcards-section .flip-container").on("click", function() {
    $(this).toggleClass("flip");
    let windowWidth = $(window).width();
    // console.log('Width: ', windowWidth);
    if (windowWidth <= 1024) {
      // console.log('Engaged');
      setTimeout(() => $(this).toggleClass("flip") , 3000);
    }
  });

  // Smooth anchor link scrolling 
  $("a[href*=\\#]").on("click", function (e) {
    let slug = this.href.split("#")[1].replace("#", "");

    // Only if no matching modal
    if( !$(".modal#modal-" + slug).length && $(".anchor#" + slug).length ) {
      e.preventDefault();
      if(this.pathname === window.location.pathname) {
        // Store hash
        let hash = this.hash;
  
        $("html, body").animate({
          scrollTop: $(hash).offset().top,
        }, 800, function(){
  
          window.location.hash = hash;
        });
      }
    }
  });

});
